import { Injectable } from "@angular/core";
import { AldenService } from "./alden.service";

@Injectable({
  providedIn: 'root'
})
export class SMTUsersService {

  constructor(private aldenService: AldenService) { }

  /**
   * Busca personas en Alfresco cuyo nombre coincida con el término indicado.
   *
   * Este método realiza una consulta al Core API de Alfresco utilizando el
   * endpoint `queries/people`, que permite buscar usuarios por nombre,
   * apellidos, email u otros atributos indexados.
   *
   * @param term Texto de búsqueda para localizar personas en el repositorio.
   * @returns Promise<any> Promesa que resuelve con los resultados de la búsqueda.
   */
  searchPeople(term: string): Promise<any> {
    const path = `queries/people?term=${term}`;
    const httpMethod = 'GET';
    return this.aldenService.callAlfrescoCoreApi(path, httpMethod);
  }

  /**
   * Obtiene los grupos a los que pertenece un usuario.
   *
   * Este método consulta el Core API de Alfresco para recuperar la lista de
   * grupos asociados al usuario identificado por `personId`. Es útil para
   * determinar roles, permisos o pertenencia a equipos dentro del repositorio.
   *
   * @param personId Identificador del usuario en Alfresco.
   * @returns Promise<any> Promesa que resuelve con la lista de grupos del usuario.
   */
  listGroups(personId: string = '-me-'): Promise<any> {
    const path = `people/${personId}/groups`;
    const httpMethod = 'GET';
    return this.aldenService.callAlfrescoCoreApi(path, httpMethod);
  }

  /**
   * Obtiene los datos de un usuario.
   *
   * Este método consulta el Core API de Alfresco para recuperar el
   * usuario asociados al usuario identificado por `personId`. 
   *
   * @param personId Identificador del usuario en Alfresco.
   * @returns Promise<any> Promesa que resuelve con el usuario.
   */
  getPerson(personId: string = '-me-'): Promise<any> {
    const path = `people/${personId}`;
    const httpMethod = 'GET';
    return this.aldenService.callAlfrescoCoreApi(path, httpMethod);
  }

}